<template>
  <div>

    <v-row>
      <v-col md="4">
        <v-card class="mx-auto mt-4">
      <v-card-title >
        <div class="title font-weight-regular" style="color:#8fb844;">Jugadores</div>
      </v-card-title>

      <v-divider class="mt-1 mx-4"></v-divider>

      <v-card-text>
        <v-chip class="mr-2" >
          <v-icon left> mdi-account-circle </v-icon>
          Jugador 1
        </v-chip>
        <v-chip
          class="ma-2"
          close
        >
         <v-icon left> mdi-account-circle </v-icon>
          Jugador 2
        </v-chip>
        <v-chip
          class="ma-2"
          close
        >
         <v-icon left> mdi-account-circle </v-icon>
          Jugador 3
        </v-chip>
        <v-chip
          class="ma-2"
          close
        >
         <v-icon left> mdi-account-circle </v-icon>
          Jugador 4
        </v-chip>
      </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-tabs
          background-color="#8fb844"
          dark
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab
          v-for="(player,index) in players"
            :key="index"
            :href="`#tab-${index}`"
          >
            <p class="mt-4 mb-0 text-right">
            Jugador {{index + 1}}
            <br/>
            <span class="" v-if="player.Nombre !=''" style="font-size: 0.5rem !important;"> ( {{player.Nombre}} ) </span>
            </p>
          </v-tab>
          <div  @click="add()" data-v-32fc7420="" tabindex="0" aria-selected="false" role="tab" class="v-tab"><i data-v-32fc7420="" aria-hidden="true" class="v-icon notranslate pl-1 pr-1 mdi mdi-account-plus-outline theme--light"></i></div>
          
          
          <v-tab-item v-for="(player,index) in players"
            :key="index" :value="`tab-${index}`">
            <v-card flat>
              <v-card-text>
               
                <v-form
                  ref="form"
              
                  lazy-validation
                >
                  <v-text-field
                   
                    :counter="10"
                    v-model="player.Nombre"
                    label="Name"
                    required
                  ></v-text-field>
                

                  <v-text-field
                    
                    label="E-mail"
                    required
                  ></v-text-field>
                    <v-btn
                    
                    depressed
                    color="error"
                  >
                    Cancelar Jugador
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>

          
        </v-tabs>
      </v-col>
    </v-row>
    


    <PermisosTable
      v-if="false"
      ref="permisos"
      :type="'Cards'"
      :edit="true"
      :rolsData="rolsData"
      :patchData="patchData"
    ></PermisosTable>
  </div>
</template>

<style scoped>
</style>


<script>
import inputSuggest from "../MainComponents/suggestPriceInput.vue";
import uvDataTable from "../MainComponents/uvDataTable.vue";
import PermisosTable from "../MainComponents/PermisosTable.vue";
import Permisos from "../../clases/Permisos.js";
const userPermissions = new Permisos("Admin");

export default {
  name: "test_component",
  components: { PermisosTable },
  props: [],
  data() {
    return {
      players:[
        {Nombre:''}
      ],
      selection: [],
      rolsData: userPermissions.roleBlock,
      patchData: userPermissions.patch,
       select: [],
        items: [
          'Cancun TIPS',
          'Restaurants and Bars',
          'Tours',
          'Transfer'

        ],
    };
  },
  methods: {
    add(){
      this.players.push({Nombre:''});
    },
    selected(val) {
      
    },
    getPermisosInfo() {
      let permisos = this.$refs.permisos.getPermisos();
      
    },
    getMergeRoles() {
      let mergedPermisos = userPermissions.MergePermissions(
        userPermissions.roleBlock,
        userPermissions.patch
      );
      
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {},
};
</script>